import React from 'react'

const CARDS = [
  { key: 'totalDeployable', label: 'Total Deployable Vehicles', gradient: 'linear-gradient(135deg, #642ca9 0%, #8b3fc8 100%)', shadow: 'rgba(100,44,169,0.45)' },
  { key: 'communicating',    label: 'Communicating',             gradient: 'linear-gradient(135deg, #059669 0%, #10b981 100%)', shadow: 'rgba(5,150,105,0.45)'  },
  { key: 'ignOff12h',        label: '> 12h Ignition Off',        gradient: 'linear-gradient(135deg, #ca8a04 0%, #eab308 100%)', shadow: 'rgba(202,138,4,0.45)'  },
  { key: 'nonCommunicating', label: 'Non-Communicating',         gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)', shadow: 'rgba(220,38,38,0.45)'  },
  { key: 'noApi',            label: 'No API',                    gradient: 'linear-gradient(135deg, #0369a1 0%, #0ea5e9 100%)', shadow: 'rgba(3,105,161,0.45)'  },
]

function Card({ label, count, gradient, shadow }) {
  return (
    <div style={{
      background: gradient,
      borderRadius: 8,
      padding: '20px 24px',
      flex: 1,
      minWidth: 150,
      boxShadow: `0 6px 24px ${shadow}, 0 2px 6px rgba(0,0,0,0.25), 0 1px 0 rgba(255,255,255,0.10) inset`,
      border: '1px solid rgba(255,255,255,0.10)',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: '48%',
        background: 'linear-gradient(180deg, rgba(255,255,255,0.10) 0%, transparent 100%)',
        pointerEvents: 'none',
      }} />
      <div style={{ fontSize: 34, fontWeight: 800, color: '#fff', lineHeight: 1, position: 'relative' }}>{count}</div>
      <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.80)', marginTop: 6, fontWeight: 600, position: 'relative' }}>{label}</div>
    </div>
  )
}

export default function FleetSnapshotCards({ snapshot }) {
  if (!snapshot) return null
  return (
    <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 24 }}>
      {CARDS.map(({ key, label, gradient, shadow }) => (
        <Card key={key} label={label} count={snapshot[key] || 0} gradient={gradient} shadow={shadow} />
      ))}
    </div>
  )
}
